module.exports = __webpack_public_path__ + "static/media/email.d6d71642.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/email.svg
// module id = 211
// module chunks = 0